import { StatusMap } from '@/components/data-table/constants';
import { Badge } from '@/components/ui/badge';
import { TENANT_ACTIVE_STATUSES } from '@/lib/tenant/constants';
import type { SubTenant, Tenant } from '@pigello/pigello-matrix';
import { DateTime } from 'luxon';
import { useMemo } from 'react';

export function getTenantStatus(tenant: Tenant | SubTenant): number | null {
  if (tenant.status == null) return null;

  if (TENANT_ACTIVE_STATUSES.includes(tenant.status)) {
    return tenant.status;
  }

  if (tenant.status !== 12) return tenant.status;

  if (tenant.latestActiveDate) {
    const isAfterNow =
      DateTime.fromISO(tenant.latestActiveDate) >= DateTime.now();

    if (isAfterNow) return 6; // active but cancelled

    const isBeforeNow =
      DateTime.fromISO(tenant.latestActiveDate) <= DateTime.now();

    if (isBeforeNow) {
      return 12; // earlier
    }
  }

  if (tenant.earliestActiveDate) {
    const isAfterNow =
      DateTime.fromISO(tenant.earliestActiveDate) >= DateTime.now();

    if (isAfterNow) {
      return 9; // upcoming
    }
  }

  return 12; // inactive
}

export function TenantBadge({ tenant }: { tenant: Tenant | SubTenant }) {
  const simulatedStatus = useMemo(() => {
    return getTenantStatus(tenant);
  }, [tenant]);

  if (simulatedStatus == null) {
    return null;
  }

  return (
    <Badge variant={StatusMap.tenant[simulatedStatus].color}>
      {StatusMap.tenant[simulatedStatus].text}
    </Badge>
  );
}
